import React from "react";
import styled from "styled-components/macro";
import check from "../../../images/unit/check.svg";
import appGroup from "../../../images/unitPopup/appGroup.png";
import assistantApp from "../../../images/unitPopup/assistantApp.png";
import unit from "../../../images/unit/Render/unit_white_logo.png";
import iphone from "../../../images/unitPopup/iphone.png";
import tuluApp from "../../../images/unitPopup/tuluApp.png";
import { Divider } from "@material-ui/core";
import { StyledBlackButton } from "../../ButtonsStyle";

const FinishModalStep1 = ({ onPress }) => {
  const _renderCheckList = () => {
    return [
      "Live Data Dashboard",
      "24/7 Customer support",
      "Liability insurance",
      "Marketing collateral",
    ].map((item, index) => {
      return (
        <CheckWrapper key={item}>
          <img
            style={{ margin: "0 15px" }}
            width={18}
            src={check}
            alt="check"
          />
          <Text>{item}</Text>
        </CheckWrapper>
      );
    });
  };

  return (
    <Wrapper>
      <div style={{ padding: "25px 0 5px" }}>
        <Title style={{ textTransform: "uppercase" }}>
          Your TULU is ready!
        </Title>

        <GrayArea>
          <div style={{ padding: "30px" }}>
            <Text fontSize={20}>The full package includes:</Text>
            <Section>
              <Img width={283} height={283} src={unit} />
              <SubSection style={{ margin: "0 23px" }}>
                <Text style={{ textDecoration: "underline" }}>TULU unit</Text>
                <Text>
                  {
                    "A fully automated\nsmart unit\nStocked with\ncurated items."
                  }
                </Text>
              </SubSection>
              <Img src={iphone} />
              <SubSection style={{ marginLeft: "23px" }}>
                <Text style={{ textDecoration: "underline" }}>TULU app</Text>
                <Text>{"Tenants explore and\nunlock items"}</Text>
                <Text
                  style={{ textDecoration: "underline", marginTop: "10px" }}
                >
                  TULU assistant app
                </Text>
                <Text>{"Operation maintenance assistant"}</Text>
                <div style={{ margin: "25px 0 10px" }}>
                  <Img style={{ marginRight: "25px" }} src={tuluApp} />
                  <Img src={assistantApp} />
                </div>
                <Img style={{ width: "140px" }} src={appGroup} />
              </SubSection>
            </Section>
          </div>
          <Divider />
          <div
            style={{
              padding: "15px 30px",
              position: "relative",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            {_renderCheckList()}
          </div>
        </GrayArea>
      </div>
      <Divider />
      <div
        style={{
          width: "100%",
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
          margin: "30px 0",
        }}
      >
        <StyledBlackButton onClick={() => onPress()}>
          Continue
        </StyledBlackButton>
      </div>
    </Wrapper>
  );
};

export { FinishModalStep1 };

const Wrapper = styled.div`
  background-color: white;
  border-radius: 25px;
  outline: 0;
  position: relative;
  display: flex;
  flex-direction: column;
`;
const GrayArea = styled.div`
  background-color: #f8f8f8;
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 24px 50px;
`;

const Title = styled.div`
  color: #4b4b4b;
  font-size: 31px;
  font-family: Manrope, serif;
  font-weight: bolder;
  line-height: 1.5;
  text-align: center;
`;
const CheckWrapper = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  align-items: center;
  margin: 10px 0;
`;

const Img = styled.img`
  object-fit: contain;
`;
const Section = styled.div`
  display: flex;
  position: relative;
  flex-direction: row;
`;

const SubSection = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
`;

const Text = styled.div`
  //text-transform: uppercase;
  color: ${({ color = "#4b4b4b" }) => color};
  font-size: ${({ fontSize = 14 }) => fontSize}px;
  white-space: pre-wrap;
  font-family: Manrope, serif;
  margin: 2px 0;
`;
